import React, { useContext } from 'react';

import { Container } from 'components/common';
import Image from 'components/common/Image';
import { LangContext } from 'providers/LangProvider';
import { Details, HindisvikWrapper } from '../Hindisvik/styles';
import { Photos } from './styles';

export const Nu = () => {
  const { lang } = useContext(LangContext);
  const alt = lang === 'is' ? 'Landselir í Hindisvík' : 'Common seals in Hindisvík';

  return (
    <section id={lang === 'is' ? 'nu' : 'the-present'}>
      <HindisvikWrapper as={Container}>
        <Details>
          <h2>{lang === 'is' ? 'Nú' : 'The Present'}</h2>
          {lang === 'is' ? (
            <>
              <p>
                Hindisvík er náttúruverndarjörð og lokuð fyrir allri umferð ferðamanna og annarra óviðkomandi, meðal
                annars til að vernda dýralíf og viðkvæman gróður.
              </p>
              <p>
                Undanfarin ár hefur landselum í látrinu fækkað umtalsvert. Samkvæmt válista Náttúrufræðistofnunar er
                landselur við Ísland í bráðri útrýmingarhættu. Honum hefur fækkað um rúmlega 75% frá því að talningar
                hófust árið 1980.
              </p>
            </>
          ) : (
            <>
              <p>
                Hindisvík is a preservation area and closed to all tourists and other unauthorized traffic, primarily to
                preserve wildlife and delicate vegetation.
              </p>
              <p>
                In recent years, the number of common seals at the haul-out site in Hindisvík has decreased rapidly.
                According to The List of Threatened Species made by Náttúrufræðistofnun Íslands (The Icelandic Institute
                of Natural History), the common seal around Iceland is severely threatened with extinction. Its number
                has decreased by 75% since the beginning of systematic counting of seals in 1980.
              </p>
            </>
          )}
          <Photos>
            <div>
              <Image alt={alt} file="hvik_tommi_1.jpg" />
              <Image alt={alt} file="hvik_tommi_2.jpg" />
            </div>
            <figcaption>
              {lang === 'is' ? 'Landselir í látrinu í Hindisvík' : 'Common seals at the haul-out site in Hindisvík'}
            </figcaption>
          </Photos>
          {lang === 'is' ? (
            <>
              <p>
                Selurinn í Hindisvík er alfriðaður og hefur verið það marga áratugi. Selasetur Íslands, í samráði við
                landeigendur, stendur fyrir rannsóknum á sel í Hindisvík auk árlegrar talningar. Því er mikilvægt að
                menn virði lokunina og fari ekki inn á rannsóknarsvæðið. Með því leggja allir sitt af mörkum og gera
                vísindamönnum kleift að afla vitneskju um náttúrulega hegðun og útbreiðslu sela til lengri tíma.
              </p>
              <p>
                <strong>Sýnið því umhverfinu virðingu.</strong>
              </p>
            </>
          ) : (
            <>
              <p>
                The seals in Hindisvík are under total conservation and have been so for many decades. Selasetur Íslands
                (The Icelandic Seal Center) has in co-operation with the owners been conducting a study of the seal
                colony in Hindisvík for many years now. For this reason it is essential that the closure of Hindisvík be
                respected. By doing so people are helping to assist scientists in gaining a long-term knowledge on the
                natural behaviour and spread of the common seal.
              </p>
              <p>
                <strong>Please take this into consideration!</strong>
              </p>
            </>
          )}
        </Details>
      </HindisvikWrapper>
    </section>
  );
};
